import { useEffect, useState } from "react";
/**
 *
 * @param {{
 * participantList:array<{
 *  participantId:number,
 *  name:string,
 *  company:string,
 *  position:string}>
 *  onChange:(array<>)=>void
 * }} props
 * @returns  {JSX.Element}
 */
function ModalKmkopReportComponent({ participantList = [], onChange = () => {} }) {
  const [participantListState, setParticipantListState] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  // Check / uncheck satu baris
  const handleCheck = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((selectedId) => selectedId !== id) : [...prev, id]));
  };

  // Check All dari toolbar
  const handleCheckAll = (checked) => {
    setSelectedIds(checked ? participantListState.map((item) => item.participantId) : []);
  };

  useEffect(() => {
    setParticipantListState(participantList);
  }, [participantList]);

  useEffect(() => {
    onChange(selectedIds);
  }, [selectedIds]);

  // Status checkbox toolbar mengikuti pilihan tabel
  const isAllChecked = participantListState.length > 0 && participantListState.every((item) => selectedIds.includes(item.participantId));

  return (
    <div className="container-fluid p-0">
      {/* Toolbar */}
      <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
        <div className="form-check">
          <input id="checkAll" type="checkbox" className="form-check-input" checked={isAllChecked} onChange={(e) => handleCheckAll(e.target.checked)} />

          <label htmlFor="checkAll" className="form-check-label">
            Check All
          </label>
        </div>

        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setSelectedIds([])} disabled={selectedIds.length === 0}>
          Uncheck All
        </button>

        <span className="text-muted small">
          {selectedIds.length} of {participantListState.length} selected
        </span>
      </div>

      {/* Table */}
      <div
        className="table-responsive border rounded"
        style={{
          maxHeight: "400px",
          overflowY: "auto",
        }}
      >
        <table className="table table-bordered table-striped table-hover mb-0">
          <thead
            className="table-dark"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 2,
            }}
          >
            <tr>
              <th scope="col" className="text-center" style={{ width: "50px" }}>
                #
              </th>
              <th scope="col">Name</th>
              <th scope="col">Company</th>
              <th scope="col">Position</th>
            </tr>
          </thead>

          <tbody>
            {participantListState.length > 0 ? (
              participantListState.map((item, index) => (
                <tr key={item.participantId}>
                  <td className="text-center">
                    <input type="checkbox" className="form-check-input" checked={selectedIds.includes(item.participantId)} onChange={() => handleCheck(item.participantId)} aria-label={`Select ${item.name}`} />
                  </td>
                  <td>{item.name}</td>
                  <td>{item.company}</td>
                  <td>{item.position}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-3">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ModalKmkopReportComponent;
